module.exports = __webpack_public_path__ + "img/ky_get.d54f66d.png";